import { makeStyles } from "@material-ui/core";

export const TruckIncomeReportCss = makeStyles(() => ({
    divFilter: {
        backgroundColor: '#f1f1f3',
        paddingTop: 16,
        paddingBottom: 16,
        paddingLeft: 24
    },
    imgV1: {
        width: '12em'
    },
    addTripButton: {
        color: 'white',
        fontSize: 16,
        borderRadius: 4,
        textTransform: 'capitalize',
        backgroundColor: '#00875a',
        marginTop: 12,
        paddingLeft: 16,
        paddingRight: 16,
        '&:hover': {
            backgroundColor: '#00875a'
        }
    },
    infoIcon: {
        fontSize: 16,
        color: '#6b778c',
        marginLeft: 10,
        cursor: 'pointer',
        marginTop: '-2px'
    },
    divEmptyState: {
        height: '90%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    divEmptyText: {
        fontSize: 18,
        fontWeight: 'bold',
    },
    divTables: {
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 16,
        paddingBottom: 34
    },
    divTitle: {
        color: 'rgba(11, 19, 35, 0.75)',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontSize: 14
    },
    mtV1: {
        marginTop: 8
    },
    mtV2: {
        marginTop: 24
    },
    arrowIcon: {
        color: 'grey',
        fontSize: 17,
        marginTop: -4
    },
    divTopCard: {
        backgroundColor: '#f2f2f2',
        width: '170px',
        borderRadius: 2,
        padding: 12
    },
    divTitleV1: {
        color: '#6d717b'
    },
    divData: {
        fontSize: 16,
        color: '#0b1323',
        fontWeight: 'bold',
        marginTop: 4
    },
    divDataLoss: {
        fontSize: 16,
        color: '#d71e1d',
        fontWeight: 'bold',
        marginTop: 4
    },
    divRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    divAlign: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    divMonth: {
        color: '#6b778c', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase'
    },
    divPdf: {
        display: 'flex', alignItems: 'center', color: '#0033cc', fontWeight: 300, letterSpacing: '0.04em', cursor: 'pointer', paddingLeft: 6, paddingRight: 4, paddingTop: 4, paddingBottom: 4,
        '&:hover': {
            backgroundColor: '#E0E0E0'
        }
    },
    mrV1: {
        marginRight: 8
    },
    cardV1: {
        borderRadius: '6px !important',
        marginTop: 12
    },
    cardContentV1: {
        padding: '24px !important'
    },
    divTitleV2: {
        color: '#6b778c', fontWeight: 300
    },
    divValue: {
        fontSize: 18,
        fontWeight: 300,
        marginTop: 6
    },
    hrV1: {
        borderTop: '1px dashed lightgrey'
    },
    divValueV1: {
        fontWeight: 300,
        color: '#0033cc'
    },
    boxShadow: {
        boxShadow: 'none !important',
        padding: '0px !important'
    },
    divCenter: {
        display: 'flex',
        alignItems: 'center',
        padding: '0px !important',
        margin: '0px !important'
    },
    rootV1: {
        padding: '0px !important',
        minHeight: '0px !important',
        '&:hover': {
            backgroundColor: '#F8F8F8',
            cursor: 'pointer'
        }
    },
    divAlignV1: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'
    },
    dFlex: {
        display: 'flex'
    },
    arrowUpV1: {
        color: 'black',
        marginTop: '-1px',
    },
    arrowDownV1: {
        color: 'black',
        marginTop: '-1px',
    },
    pdV1: {
        padding: '0px !important'
    },
    divItems: {
        width: '100%',
    },
    divItemsV1: {
        backgroundColor: '#F5F5F5',
        paddingTop: 11,
        paddingBottom: 1,
        paddingLeft: 16,
        paddingRight: 16,
        borderRadius: 4,
        marginTop: 4
    },
    divAlignV2: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10
    },
    divAlignV3: {
        display: 'flex', alignItems: 'center'
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(2.3)",
        color: "#c7c7c7"
    },
    divProfit: {
        fontSize: 18,
        fontWeight: 300
    },
    profit: {
        fontSize: 18,
        color: '#00875a',
        fontWeight: 300
    },
    loss: {
        fontSize: 18,
        color: '#d71e1d',
        fontWeight: 300
    },
    mlV5: {
        marginLeft: 5
    },
    divMonthlyReport: {
        backgroundColor: '#f1f1f3',
        paddingTop: 16,
        paddingBottom: 16,
        paddingLeft: 24,
        paddingRight: 24,
        height: '100%',
        overflow: 'auto',
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#585858'
        }
    },
    rowLoss: {
        '& .MuiTableRow-root': {
            backgroundColor: 'red'
        }
    },
    divColorWhite: {
        color: 'white'
    },
    divColorV1: {
        '&:last-child': {
            color: 'white'
        }
    },
    textV1: {
        marginLeft: 6,
        "&:last-child": {
            color: '#00875a'
        }
    },
    textV3: {
        color: 'white'
    },
    revenue: {
        fontWeight: 'normal'
    },
    expenses: {
        fontWeight: 'normal'
    },
    divTitleV3: {
        color: '#0b1323',
    },
    fwbold: {
        fontWeight: 300
    },
    dataLossV1: {
        color: '#d71e1d'
    }
}));

export const PartyIncomeReportCss = makeStyles(() => ({
    divColorWhite: {
        color: 'white',
        fontWeight: 'bold'
    },
    infoIcon: {
        fontSize: 16,
        color: '#6b778c',
        marginLeft: 10,
        cursor: 'pointer',
        marginTop: '-2px'
    },
    fwBold: {
        fontWeight: 'bold'
    },
    fwNormal: {
        fontWeight: 'normal'
    },
    arrowIcon: {
        color: 'grey',
        fontSize: 17,
        marginTop: -4
    },
    mtV1: {
        marginTop: 16
    },
    divMonthlyReport: {
        backgroundColor: '#f1f1f3',
        paddingTop: 16,
        paddingBottom: 16,
        paddingLeft: 24,
        paddingRight: 24,
        height: '100%',
        overflow: 'auto',
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#585858'
        }
    },
    divAlign: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
    },
    divMonth: {
        color: '#6b778c', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase'
    },
    divPdf: {
        display: 'flex', alignItems: 'center', color: '#0033cc', fontWeight: 300, letterSpacing: '0.04em', cursor: 'pointer', paddingLeft: 6, paddingRight: 4, paddingTop: 4, paddingBottom: 4,
        '&:hover': {
            backgroundColor: '#E0E0E0'
        }
    },
    mrV1: {
        marginRight: 8
    },
    cardV1: {
        borderRadius: '6px !important',
        marginTop: 12
    },
    cardContentV1: {
        padding: '24px !important'
    },
    divTitleV2: {
        color: '#6b778c', fontWeight: 300
    },
    divValue: {
        fontSize: 18,
        fontWeight: 300,
        marginTop: 6
    },
    hrV1: {
        borderTop: '1px dashed lightgrey'
    },
    divTitleV3: {
        color: '#0b1323',
    },
    divValueV1: {
        fontWeight: 300,
        color: '#0033cc'
    },
    boxShadow: {
        boxShadow: 'none !important',
        padding: '0px !important'
    },
    divCenter: {
        display: 'flex',
        alignItems: 'center',
        padding: '0px !important',
        margin: '0px !important'
    },
    rootV1: {
        padding: '0px !important',
        minHeight: '0px !important',
        '&:hover': {
            backgroundColor: '#F8F8F8',
            cursor: 'pointer'
        }
    },
    divAlignV1: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'
    },
    dFlex: {
        display: 'flex'
    },
    arrowUpV1: {
        color: 'black',
        marginTop: '-1px',
    },
    arrowDownV1: {
        color: 'black',
        marginTop: '-1px',
    },
    pdV1: {
        padding: '0px !important'
    },
    divItems: {
        width: '100%',
    },
    divAlignV2: {
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10
    },
    divAlignV3: {
        display: 'flex', alignItems: 'center'
    },
    fwbold: {
        fontWeight: 300
    },
    bullet: {
        display: "inline-block",
        margin: "0 8px",
        transform: "scale(2.3)",
        color: "#c7c7c7"
    },
    mtV11: {
        marginTop: 8
    },
    divProfit: {
        fontSize: 18,
        fontWeight: 300
    },
    profit: {
        fontSize: 18,
        color: '#00875a',
        fontWeight: 300
    },
    divBalance: {
        fontSize: 18,
        fontWeight: 300
    },
    divV1: {
        marginLeft: 108
    },
    divTextV1: {
        fontSize: 16,
        color: '#6b778c',
        width: '100%',
        textAlign: 'center'
    },
    divItemsV1: {
        backgroundColor: '#F5F5F5',
        paddingTop: 11,
        paddingBottom: 1,
        paddingLeft: 16,
        paddingRight: 16,
        borderRadius: 4,
        marginTop: 4
    },
    divCollection: {
        fontSize: 18,
        fontWeight: 'bold'
    },
    linearProgress: {
        height: 12,
        borderRadius: 4,
        backgroundColor: '#e5e5e5'
    },
    divCollectionContainer: {
        marginTop: 24
    },
    mtV2: {
        marginTop: 8
    },
    barColorV1: {
        backgroundColor: '#f99c10'
    },
    barColorV2: {
        backgroundColor: '#00875a'
    },
    divCollectionZero: {
        color: '#d71e1d',
        fontWeight: 'bold',
        fontSize: 18
    },
    addTripButton: {
        color: 'white',
        fontSize: 16,
        borderRadius: 4,
        textTransform: 'capitalize',
        backgroundColor: '#00875a',
        marginTop: 12,
        paddingLeft: 16,
        paddingRight: 16,
        '&:hover': {
            backgroundColor: '#00875a'
        }
    },
    divEmptyState: {
        height: '90%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    divEmptyText: {
        fontSize: 18,
        fontWeight: 'bold',
    },
    imgV1: {
        width: '10em'
    },
}));

export const ProfitLossReportCss = makeStyles(() => ({
    divFilter: {
        backgroundColor: '#f1f1f3',
        paddingTop: 16,
        paddingBottom: 16,
        paddingLeft: 24
    },
    nested:{
        paddingLeft:0,
        padding:0,
        paddingBottom:12
    },
    listPrimary:{
        '& .MuiListItemText-primary':{
            fontWeight:600,
            fontSize:14,
        }
    },
    listSec:{
        '& .MuiListItemText-primary':{
            fontWeight:600,
            fontSize:14,
            color:"rgba(11, 19, 35, 0.75)"
        }
    },
    listPrimaryAmount:{
        fontWeight:600,
        fontSize:14,
    },
    listSecAmount:{
        fontWeight:600,
        fontSize:14,
        color:"rgba(11, 19, 35, 0.75)"
    },
    listHead:{
        paddingLeft:0,
        fontWeight:600,
        fontSize:14,
        padding:0,
        paddingBottom:0,
        cursor:'pointer'
    },
    nestedRoot:{
        marginLeft:20,
        padding:"12px 16px",
        paddingBottom:0,
        backgroundColor:'#f6f6f8',
        borderRadius:8
    },  
    divAlignProfit: {
        backgroundColor: '#00875a',
        color: 'white',
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 24,
        paddingRight: 24,
        fontWeight: 'bold',
        fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    divAlignLoss: {
        backgroundColor: '#d71e1d',
        color: 'white',
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 24,
        paddingRight: 24,
        fontWeight: 'bold',
        fontSize: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    divReportData: {
        padding: 24,
        paddingBottom: 16
    },
    gridContainer: {
        border: "2px solid #dfe2e5",
        borderRadius: 4,
    },
    gridContainerV1: {
        paddingTop: 12,
        paddingBottom: 12,
        fontWeight: 300,
        paddingLeft: 16,
        paddingRight: 16
    },
    gridContainerV2: {
        paddingTop: 12,
        paddingBottom: 12,
        backgroundColor: '#D7DFE5',
        fontWeight: 'bold',
        paddingLeft: 16,
        paddingRight: 16
    },
    gridContainerV3: {
        backgroundColor: '#F6F6F8',
        paddingTop: 12,
        paddingBottom: 12,
        fontWeight: 300,
        paddingLeft: 16,
        paddingRight: 16
    },
    gridContainerV4: {
        fontWeight: 300,
        paddingLeft: 50,
        paddingRight: 50,
        paddingBottom: 12,
    },
    gridContainerList: {
        fontWeight: 300,
        paddingLeft: 28,
        paddingRight: 50,
        paddingBottom: 8,
    },
    gridContainerV5: {
        marginTop: 12
    },
    gridContainerV6: {
        paddingTop: 12,
        paddingBottom: 12,
        fontWeight: 300,
        backgroundColor: '#F6F6F8',
        paddingLeft: 16,
        paddingRight: 16
    },
    gridContainerV7: {
        paddingLeft: 50,
        paddingRight: 50,
        fontWeight: 300,
        paddingBottom: 12,
    },
    gridContainerV8: {
        marginTop: 12
    },
    gridContainerV10: {
        backgroundColor: '#00875a',
        color: 'white',
        fontSize: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        paddingBottom: 12,
        fontWeight: 'bold'
    },
    gridContainerV11: {
        fontWeight: 'bold',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
    },
    gridContainerV12: {
        fontWeight: 'bold',
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,
    },
    gridContainerV13: {
        backgroundColor: '#d71e1d',
        color: 'white',
        fontSize: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 12,
        paddingBottom: 12,
        fontWeight: 'bold'
    },
    divEmptyState: {
        height: '90%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    },
    divEmptyText: {
        fontSize: 18,
        fontWeight: 'bold',
        marginTop: 10
    },
    addTripButton: {
        color: 'white',
        fontSize: 16,
        borderRadius: 4,
        textTransform: 'capitalize',
        backgroundColor: '#00875a',
        marginTop: 12,
        paddingLeft: 16,
        paddingRight: 16,
        '&:hover': {
            backgroundColor: '#00875a'
        }
    },
    profitLossIcon: {
        fontSize: '14em'
    },
    amountLoss: {
        color: '#d71e1d'
    }
}));